import * as fromCombinedExploreAdverts from '@web-platform/shared-universal-redux/src/state/shared/adverts/combinedExplore';
import * as fromCombinedResultsAdverts from '@web-platform/shared-universal-redux/src/state/shared/adverts/combinedResults';
import * as fromHomepageAdverts from '@web-platform/shared-universal-redux/src/state/shared/adverts/homepage';
import * as fromFlightSearchResults from '@web-platform/shared-universal-redux/src/state/shared/flightSearchResults';
import { combineReducers } from 'redux';

import entitiesSearchResults from './entitiesSearchResults';

import type { Status } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/adverts';
import type {
  CombinedResultsFlightsInlineAdvert,
  CombinedResultsFlightsInlineAdvertById,
} from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/combinedResultsFlightsInline';
import type { DestinationExplorerState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/destinationExplorer';
import type {
  GraphicPromo,
  GraphicPromoById,
} from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/graphicPromo';
import type {
  HomepageHero,
  HomepageHeroById,
} from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/homepageHero';
import type {
  HomepageVideo,
  HomepageVideoById,
} from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/homepageVideo';
import type {
  NavCard,
  NavCardById,
} from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/navCard';
import type { CurrentAdvertIdsState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entityCollections/currentAdvertIds';
import type { CurrentFlightItineraryIdsState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entityCollections/currentFlightItineraryIds';
import type { State } from '@web-platform/shared-universal-types/src/redux/banana/state/state-banana-types';
import type {
  Carrier,
  CarrierMultipleAggregate,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/carriers';

export default combineReducers({
  entitiesSearchResults,
});

// entityCollections
export const flightItineraryCurrentIds = (state: State): CurrentFlightItineraryIdsState =>
  fromFlightSearchResults.getCurrentFlightItineraryIds(state.shared.flightSearchResults);
export const advertCurrentIds = (state: State): CurrentAdvertIdsState =>
  fromCombinedResultsAdverts.getCurrentAdvertIds(state.shared.adverts.combinedResults);

// priceBands
export const getPriceBands = (state: State) =>
  fromFlightSearchResults.getPriceBands(state.shared.flightSearchResults);

// entitiesSearchResults
export const combinedResultsFlightsInlineAdvert = <T extends CombinedResultsFlightsInlineAdvert>(
  state: State,
  id: string,
): T =>
  fromCombinedResultsAdverts.getCombinedResultsFlightsInlineAdvert(
    state.shared.adverts.combinedResults,
    id,
  ) as T;

export const allCombinedResultsFlightsInlineAdverts = (
  state: State,
): CombinedResultsFlightsInlineAdvertById =>
  fromCombinedResultsAdverts.getAllCombinedResultsFlightsInlineAdverts(
    state.shared.adverts.combinedResults,
  );
export const graphicPromo = (state: State, id: string): GraphicPromo =>
  fromHomepageAdverts.getGraphicPromoAdvert(state.shared.adverts.homepage, id);
export const graphicPromos = (state: State): GraphicPromoById =>
  fromHomepageAdverts.getAllGraphicPromoAdverts(state.shared.adverts.homepage);
export const homepageHero = (state: State, id: string): HomepageHero =>
  fromHomepageAdverts.getHomepageHeroAdvert(state.shared.adverts.homepage, id);
export const homepageHeroes = (state: State): HomepageHeroById =>
  fromHomepageAdverts.getAllHomepageHeroAdverts(state.shared.adverts.homepage);
export const homepageVideo = (state: State, id: string): HomepageVideo =>
  fromHomepageAdverts.getHomepageVideoAdvert(state.shared.adverts.homepage, id);
export const homepageVideos = (state: State): HomepageVideoById =>
  fromHomepageAdverts.getAllHomepageVideoAdverts(state.shared.adverts.homepage);
export const destinationExplorerAdvert = (state: State): DestinationExplorerState =>
  fromCombinedExploreAdverts.getDestinationExplorer(state.shared.adverts.combinedExplore);
export const getCreativesStatus = (state: State): Status =>
  fromHomepageAdverts.getCreativesStatus(state.shared.adverts.homepage);
export const navCardAdvert = (state: State, id: string): NavCard =>
  fromHomepageAdverts.getNavCardAdvert(state.shared.adverts.homepage, id);
export const allNavCardAdverts = (state: State): NavCardById =>
  fromHomepageAdverts.getAllNavCardAdverts(state.shared.adverts.homepage);
export const flightCarrier = (state: State, id: number) =>
  fromFlightSearchResults.flightCarrier(state.shared.flightSearchResults, id);
export const flightCarriers = (state: State): Record<number, Carrier> =>
  fromFlightSearchResults.flightAllCarriers(state.shared.flightSearchResults);
export const flightCarriersMultiple = (state: State): CarrierMultipleAggregate | null =>
  fromFlightSearchResults.flightCarriersMultiple(state.shared.flightSearchResults);
export const flightCarriersCurrentResultIds = (state: State): number[] =>
  fromFlightSearchResults.flightCarriersCurrentResultIds(state.shared.flightSearchResults);
